enum LedgerTransferStatus {
    WAITING = 'WAITING',
    COMPLETED = 'COMPLETED',
};
export default LedgerTransferStatus;